import { Component, OnInit } from '@angular/core';

import { BreadcrumbService } from '@library/core/services';

@Component({
   selector: 'lib-new-report',
   template: `<lib-reports-display></lib-reports-display>`,
})
export class NewReportComponent implements OnInit {

   constructor( private breadcrumbs: BreadcrumbService ) { }

   ngOnInit(): void {
      this.breadcrumbs.newCrumb({ label: 'Reports', path: '/report' });
      this.breadcrumbs.addCrumble( 'New' );
   }
}
